import {Component, computed, inject, input, output, signal} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {CompanyFormModel} from './company-form.model';
import {Label} from '../../../../components/label/label';
import {TranslatePipe} from '@ngx-translate/core';
import {TextInput} from '../../../../components/text-input/text-input';
import {ToggleSwitch} from '../../../../components/toggle-switch/toggle-switch';
import {AddressForm} from '../address-form/address-form';
import {Editor} from '../../../../components/editor/editor';
import {PartyDropdown} from '../../../../components/party-dropdown/party-dropdown';
import {LegalEntityDropdown} from '../../../finances/components/legal-entity-dropdown/legal-entity-dropdown';
import {LocalDropdown} from '../../../../components/local-dropdown/local-dropdown';
import {PaymentModeDropdown} from '../payment-mode-dropdown/payment-mode-dropdown';
import {DirectDebitForm} from '../direct-debit-form/direct-debit-form';
import {PartyType, PaymentMethod} from '../../../../../api';
import {AiButton} from '../../../../components/buttons/ai-button/ai-button';
import {CustomerAnalysisDialog} from '../customer-analysis-dialog/customer-analysis-dialog';
import {CurrentUserService} from '../../../../services/current-user.service';

@Component({
  selector: 'elcia-company-form',
  imports: [
    ReactiveFormsModule,
    Label,
    TranslatePipe,
    TextInput,
    ToggleSwitch,
    AddressForm,
    Editor,
    PartyDropdown,
    LegalEntityDropdown,
    LocalDropdown,
    PaymentModeDropdown,
    DirectDebitForm,
    AiButton,
    CustomerAnalysisDialog
  ],
  templateUrl: './company-form.html',
  styleUrl: './company-form.scss',
})

export class CompanyForm {

  private readonly currentUserService = inject(CurrentUserService);

  form = input.required<FormGroup<CompanyFormModel>>();

  // Null in create mode: there is nothing to analyse until the company is saved
  customerId = input<number | null>(null);

  // Bubbles the selected payment method up so the smart component can gate the direct-debit mandate
  readonly paymentMethodChange = output<PaymentMethod | null>();

  protected readonly contactPartyTypes = [PartyType.Contact];


  protected readonly selectedPaymentMethod = signal<PaymentMethod | null>(null);
  protected readonly isDirectDebit = computed(() => this.selectedPaymentMethod() === PaymentMethod.DirectDebit);

  protected onPaymentMethodChange(method: PaymentMethod | null): void {
    this.selectedPaymentMethod.set(method);
    this.paymentMethodChange.emit(method);
  }

  // The analysis feeds invoices and timesheets to the model, so the endpoint requires both permissions
  protected readonly canAnalyse = computed(() =>
    this.customerId() != null
    && !!this.currentUserService.hasFinanceAccess()
    && !!this.currentUserService.hasTimesheetAccess());

  protected readonly isAnalysisDisplayed = signal(false);

}
